<template>
  <div>
    <sc-form
      autocomplete="off"
      ref="contactForm">

        <template slot="fields" slot-scope="{ fields }">
          <div class="mainContent">

            <div class="mainContent__paragraphs">
              <p>
                Informe seu(s) o(s) contato(s) na transportadora, geralmente é o responsável pela sua conta ou comercial da transportadora.
              </p>
              <p>
                Esse contato vai receber os dados para configurar a integração com a Intelipost.
              </p>
          </div>

            <div class="mainContent__inputs">

              <div class="mainContent__inputs__fullname">
                <label for="fullname">
                  <strong>Nome Completo:</strong>
                </label>
                <sc-input v-model="fullname"></sc-input>
            </div>

            <div class="mainContent__inputs__email">
              <label for="email">
                <strong>Email  de contato na transportadora:</strong>
              </label>
              <sc-input type="email" v-model="email"></sc-input>
            </div>

            <div class="mainContent__inputs__phone">
              <label for="phone">
                <strong>Telefone:</strong>
              </label>
              <sc-input type="phone" v-mask="'(##) #####-####'" v-model="phone"></sc-input>
            </div>
            </div>
          </div>
          <help-button/>
        </template>


        <template slot="actions" slot-scope="{ isValid }">
          <sc-button
            text="Voltar"
            theme="default"
            type="button"
            @click="setActiveStep(1)"/>
          <sc-button
            text="Próximo"
            theme="primary"
            @click="navigateNext"
            type="button"/>
        </template>
      </sc-form>
  </div>
</template>

<script>
  import { createNamespacedHelpers } from 'vuex';
  import {
    ScButton,
    ScForm,
    ScField,
    ScInput,
} from '@intelipost-js/secure-components';
import { mask } from 'vue-the-mask';
import HelpButton from '../help-button/HelpButton.vue';

  const { mapState, mapMutations } = createNamespacedHelpers('integrations/integrationsStep');

  export default {
    name: 'sc-contact',
    directives: { mask },
    data() {
      return {
        fullname: '',
        email: '',
        phone: '',
      };
    },
    computed: {
      ...mapState([
        'activeStep',
      ]),
    },
    methods: {
      ...mapMutations([
        'setActiveStep',
      ]),
      navigateNext() {
        this.setActiveStep(3);
      },
    },

    components: {
      ScButton,
      ScForm,
      ScField,
      ScInput,
      HelpButton,
    },
  };

</script>

<style lang='scss' scoped>
.mainContent {
  display: flex;
  flex-direction: column;
  gap: 40px;

  &__paragraphs {
    display: flex;
    flex-direction: column;
    gap: 30px;
  }

  &__inputs {
    display: flex;
    flex-direction: column;
    gap: 30px;
    max-width: 440px;
    & > * {
      display: flex;
      align-items: center;
      justify-content: space-between;
    }
  }
}
</style>



// WEBPACK FOOTER //
// node_modules/@intelipost-modules/secure-integrations/features/integrations-app-v2/components/sc-contact/ScContact.vue